/* 🤖 this file was generated by svg-to-ts */
export const matIconHeadsetMic: {
  name: 'headset-mic';
  data: string;
} = {
  name: 'headset-mic',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 14v4h-2v-4h2M7 14v4H6c-.55 0-1-.45-1-1v-3h2m5-13a9 9 0 0 0-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10a9 9 0 0 0-9-9z"/></svg>`
};
